import React from 'react';

/**
 * Generic Skeleton Loading Component
 * Uses Tailwind's animate-pulse for shimmer effect.
 * 
 * @param {string} className - Additional classes for dimensions (w-*, h-*) and rounded corners
 */
const Skeleton = ({ className = "" }) => {
    return (
        <div
            className={`animate-pulse bg-gray-200 dark:bg-gray-700 rounded-md ${className}`}
        />
    );
};

export default Skeleton;
